import EditContactContainer from '../containers/ViewContactContainer';

const EditContactPage = () => {
  return <EditContactContainer />;
};

export default EditContactPage;
